import React, { useState, useEffect, useContext, useRef } from "react";
import {
  API_TOKEN_NAME,
  WEBSITEPAGE_URL,
  USER_ID,
  IMAGE_URL,
  SITE_URL,
  USER_LOCAL_ID,
} from "../../constants";
import { scAxiosAdmin } from "../..";
import $ from "jquery";
import logo from "../../images/newlogo.png";
import icons_rotate from "../../images/icons-rotate.png";
import hotline_phone from "../../images/hotline_phone.svg";
import PopupIndex2 from "../../component/frontend/PopupIndex2";
import PopupIndex3 from "../../component/frontend/PopupIndex3";
import PopupIndex4 from "../../component/frontend/PopupIndex4";
import PopupIndex5 from "../../component/frontend/PopupIndex5";
import PopupPatientLists from "../../component/frontend/PopupPatientLists";
import PopupRegister from "../../component/frontend/PopupRegister";
import "../frontend/homepage.css";
import CollapsibleButton from "../CollapsibleButton";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import { MyContext } from "../MyProvider";
import PatientRegisterPopup from "./PatientRegistrationPopup";
import BookAppointmentPopup from "./BookAppointmentPopup";
import CartPopUp from "./CartPopUp";
import BookTestPopUp from "./BooTestPopUp";
import CorporateRequestPopUp from "./CorporateRequestPopUp";
import { HiMenuAlt3 } from "react-icons/hi";
import { FaWhatsapp } from "react-icons/fa";
import { TfiHeadphoneAlt } from "react-icons/tfi";
import {
  BrowserView,
  MobileView,
  isMobile,
  isTablet,
} from "react-device-detect";
import { FaMapMarkerAlt } from "react-icons/fa";

const getDefaultSearch = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getdefaultsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSearchData = (data) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request("/homesetting/getsearchdata", {
      method: "get",
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
      },
      params: {
        ...data,
      },
    });
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};
const getSingleHeaderAnnoucementData = (id) => {
  return new Promise((resolve, reject) => {
    const req = scAxiosAdmin.request(
      "/headerannoucement/getsingleheaderannoucement/" + id,
      {
        method: "get",
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
        },
      }
    );
    req.then((res) => resolve(res.data)).catch((err) => reject(err));
  });
};

const Header = () => {
  const [state, setState] = useState({
    search_keywords: "",
    default_doctors: [], // Initialize with empty arrays
    default_packages: [],
    default_departments: [],
    default_publications: [],
    header_annoucement_text: "",
    header_annoucement_link: "",
    header_phone_no: "",
    isPopupOpen: false,
    patientRegPopup: false,
    showPatientRegPopup: "",
    showSearchPopup: false,
  });
  const [headerData, setHeaderData] = useState([]);

  const handleChange = (event) => {
    setState((prevState) => ({
      ...prevState,
      [event.target.name]: event.target.value,
    }));
  };

  const refreshGetDefaultSearchData = () => {
    getDefaultSearch()
      .then((res) => {
        setState((prevState) => {
          return {
            ...prevState, // Keep the previous state intact
            default_doctors: res.status === true ? res.doctor_data || [] : [],
            default_packages: res.status === true ? res.package_data || [] : [],
            default_publications:
              res.status === true ? res.publication_data || [] : [],
            default_departments:
              res.status === true ? res.department_data || [] : [],
          };
        });
      })
      .catch((err) => {
        console.error(err);
      });
  };

  const useDebounce = (fn, delay) => {
    const timeoutRef = useRef(null);

    return (event) => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
      timeoutRef.current = setTimeout(() => {
        fn(event);
      }, delay);
    };
  };

  const handleKeyUp = useDebounce((event) => {
    const data = {
      keywords: state.search_keywords,
    };
    getSearchData(data)
      .then((res) => {
        setState((prevState) => ({
          ...prevState, // Keep previous state intact
          default_doctors: res.status === true ? res.doctor_data : [],
          default_packages: res.status === true ? res.package_data : [],
          default_publications: res.status === true ? res.publication_data : [],
          default_departments: res.status === true ? res.department_data : [],
          enableShdo: false, // Update enableShdo without affecting other state
        }));
      })
      .catch((err) => {
        console.log(err);
      });
  }, 500);

  const showSearchResult = async () => {
    refreshGetDefaultSearchData(),
      setState((prevState) => ({
        ...prevState, // Keep previous state intact
        showSearchPopup: !prevState.showSearchPopup, // Toggle showSearchPopup
      })); // Ensure API call after state update
  };

  const closeSearchPopUp = () => {
    setState(
      (prevState) => ({
        ...prevState, // Keep previous state intact
        showSearchPopup: false, // Close the search popup
      })
      // refreshGetDefaultSearchData
    ); // Ensure API call after state update
  };

  const refreshgetSingleHeaderAnnoucementData = (id) => {
    getSingleHeaderAnnoucementData(id)
      .then((res) => {
        if (res.status === true) {
          var records = res.data;
          setState({
            header_annoucement_text: records.header_annoucement_text,
            header_annoucement_link: records.header_annoucement_link,
            header_phone_no: records.header_phone_no,
          });
        } else {
          setState({
            header_annoucement_text: "",
            header_annoucement_link: "",
            header_phone_no: "",
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    const headerDataList = {
      ids: [31, 33, 34, 36],
    };
    const getHeaderData = (data) => {
      try {
        const req = scAxiosAdmin
          .post(`/settings/get_multiple`, headerDataList, {
            // .request(`/staticpages/getsinglestaticpageslugdata/career`, {
            method: "get",
            headers: {
              Accept: "application/json",
              // Authorization: "Bearer " + localStorage.getItem(API_TOKEN_NAME),
            },
          })
          .then((data) => {
            if (data.status === 200) {
              // console.log('your log output',data)
              // setStaticPageData(data.data.data);
              setHeaderData(data.data);
            }
          })
          .catch((e) => {
            console.log("your log output", e);
          });
      } catch (error) {}
    };
    getHeaderData();
  }, []);

  useEffect(() => {
    let header_annoucement_id = "1";
    // refreshgetSingleHeaderAnnoucementData(header_annoucement_id);
    window.addEventListener("storage", handleStorageChange);
    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const handleStorageChange = () => {
    setState((prevState) => ({ ...prevState }));
  };

  let patient_user_id = localStorage.getItem(USER_LOCAL_ID);
  const UserName = localStorage.getItem("patient_name");
  const cart = localStorage.getItem("totalAmount");

  return (
    <div>
      <div
        className="d-none d-md-flex flex-column"
        style={{
          position: "fixed",
          top: "30vh",
          right: "0",
          // padding: "10px",
          // borderTopLeftRadius: "20px",
          // borderBottomLeftRadius: "20px",
          // border: "2px solid #ccc", // Border for the first two buttons
          // borderRight: "none", // No right border to attach it to the edge
          // backgroundColor: "#f9f9f9", // Slight background color for visibility
          // display: "flex",
          // flexDirection: "column",
          // gap: "10px",
          // alignItems: "center",
          zIndex: 99999,
        }}
      >
        <div
          className=""
          style={{
            padding: "10px",
            borderTopLeftRadius: "20px",
            borderBottomLeftRadius: "20px",
            border: "2px solid #AF9763", // Border for the first two buttons
            borderRight: "none", // No right border to attach it to the edge
            backgroundColor: "transparent", // Slight background color for visibility
            display: "flex",
            flexDirection: "column",
            gap: "10px",
            alignItems: "center",
            zIndex: 99999,
          }}
        >
          {/* First Button */}
          <a
            href={`tel:${
              headerData.length > 0 && headerData[0].value
                ? headerData[0].value
                : "10666"
            }`}
          >
            <button
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%", // Rounded button
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <img
                src="/assets/images/call_update.svg"
                alt="Call"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </button>
          </a>

          {/* Second Button */}
          <Link to={"/pages/emergency"}>
            <button
              style={{
                width: "72px",
                height: "72px",
                borderRadius: "50%", // Rounded button
                border: "none",
                padding: 0,
                backgroundColor: "transparent",
                cursor: "pointer",
              }}
            >
              <img
                src="/assets/images/emargency_update.svg"
                alt="Emergency"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  borderRadius: "50%",
                }}
              />
            </button>
          </Link>
        </div>
        <div className="" style={{ padding: "10px", zIndex: 99999 }}>
          {/* Third Button outside the border, below the first two */}
          <button
            className="d-none d-md-flex"
            style={{
              width: "72px",
              height: "72px",
              borderRadius: "50%", // Rounded button
              border: "none",
              padding: 0,
              backgroundColor: "transparent",
              cursor: "pointer",
              animation: "shakeButton 1s ease-in-out infinite",
            }}
          >
            <img
              src="/assets/images/jci-gold-seal 1.png"
              alt="Gold Seal"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                borderRadius: "50%",
              }}
            />
          </button>
        </div>
      </div>

      {/* CSS Animation */}
      <style jsx>{`
        @keyframes shakeButton {
          0% {
            transform: translateX(0); /* No movement */
          }
          25% {
            transform: translateX(-10px); /* Move left */
          }
          50% {
            transform: translateX(10px); /* Move right */
          }
          75% {
            transform: translateX(-10px); /* Move left again */
          }
          100% {
            transform: translateX(0); /* Return to original position */
          }
        }
      `}</style>
      {state.header_annoucement_text ? (
        <header className="top-part">
          <div className="container">
            <p>
              <a
                href={state.header_annoucement_link}
                target="_blank"
                style={{ color: "#fff", textDecoration: "none" }}
              >
                {state.header_annoucement_text}
              </a>
            </p>
          </div>
        </header>
      ) : (
        ""
      )}
      <div
        className="text-light p-2 d-none d-md-block"
        style={{ backgroundColor: "#AF9763" }}
      >
        <div className="container">
          <div className="row px-1">
            <div
              className="col-12 col-md-9 col-xl-8"
              style={{
                display: "flex",
                gap: 5,
                justifyContent: "flex-start",
              }}
            >
              <div className="d-flex justify-content-between align-items-start">
                <a
                  href={`tel:${
                    headerData.length > 0 && headerData[0].value
                      ? headerData[0].value
                      : "10666"
                  }`}
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                  }}
                >
                  <i className="fa fa-phone" style={{ marginRight: "5px" }}></i>
                  {headerData.length > 0 && headerData[0].value
                    ? headerData[0].value
                    : "10666"}
                </a>
                <img
                  className="ms-2 mt-1"
                  src="/assets/images/Line 1.png"
                  alt=""
                />
              </div>
              <div className="d-flex justify-content-between align-items-start">
                <a
                  href="tel:+880 2-2222-62466"
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                    textWrap: "nowrap",
                  }}
                >
                  <TfiHeadphoneAlt className="mx-2" />
                  International:
                  <span>
                    {headerData.length > 0 && headerData[1].value
                      ? headerData[1].value
                      : "+880 2-2222-62466"}{" "}
                  </span>
                </a>
                <img
                  className="ms-2 mt-1"
                  src="/assets/images/Line 1.png"
                  alt=""
                />
              </div>
              <div className="d-flex justify-content-between align-items-start">
                <a
                  href="tel:+880191-4001214"
                  style={{
                    color: "#ffff",
                    textDecoration: "none",
                    textWrap: "nowrap",
                  }}
                >
                  <FaWhatsapp className="mx-2" />
                  WhatsApp:
                  <span>
                    {headerData.length > 0 && headerData[2].value
                      ? headerData[2].value
                      : "+880191-4001214"}{" "}
                  </span>
                </a>

                <img
                  className="ms-2 mt-1"
                  src="/assets/images/Line 1.png"
                  alt=""
                />
              </div>

              {/* <br className="d-lg-none" /> */}
              <a
                target="_blank"
                className="header-location"
                href={
                  headerData.length > 0 && headerData[3].value
                    ? headerData[3].value
                    : "https://maps.app.goo.gl/UJS8gnWhCddNuwDH9"
                }
                style={{
                  // color: "#ffff",
                  textDecoration: "none",
                  textWrap: "nowrap",
                }}
              >
                <FaMapMarkerAlt className="make-packages-price-orange" />
              </a>
            </div>
            <div
              className="col-12 col-md-3 col-xl-4 top-header d-flex justify-content-start justify-content-md-end upperHeaderMenus flex-wrap"
              style={{
                rowGap: "2px",
              }}
            >
              <Link style={{ textDecoration: "none", fontSize: "14px" }} to="/">
                Home
              </Link>

              {/* <img src="/assets/images/Line 1.png" alt="" /> */}
              <Link
                style={{ textDecoration: "none", fontSize: "14px" }}
                to="/page/about"
              >
                About
              </Link>
              {/* <img src="/assets/images/Line 1.png" alt="" /> */}
              <Link
                style={{ textDecoration: "none", fontSize: "14px" }}
                to="/pages/departments"
              >
                Departments
              </Link>
              <Link
                style={{ textDecoration: "none", fontSize: "14px" }}
                to="/pages/career"
              >
                Career
              </Link>
              <Link
                style={{ textDecoration: "none", fontSize: "14px" }}
                to="/page/contact"
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      <header
        className="header-part hrad subpages_header py-0 shadow"
        id="doctor-profile"
      >
        <nav className="navbar" style={{ backgroundColor: "#F7F5EF" }}>
          <div className="container py-2 pr-2" style={{ flexWrap: "nowrap" }}>
            <div
              className="d-flex justify-content-between align-items-center w-100 gap-0 gap-md-0"
              style={{ zIndex: 999 }}
            >
              <div
                style={{ width: isMobile ? "20%" : "10%" }}
                className="d-flex justify-content-start"
              >
                <a href="/">
                  <img
                    style={{ maxWidth: isMobile ? "65px" : "" }}
                    className={`${isMobile ? "none" : "img-fluid"}`}
                    src="/assets/images/updated_logo.png"
                    alt="logo2"
                  />
                </a>
              </div>

              <div
                className="d-flex justify-content-between align-items-center"
                style={{
                  width: isMobile ? "80%" : "85%",
                  position: "relative",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div
                  className=""
                  style={{
                    position: "relative",
                    width: localStorage.getItem(USER_LOCAL_ID) ? "75%" : "90%",
                  }}
                >
                  <input
                    type="text"
                    className="form-control py-1 py-md-2 shadow "
                    name="search_keywords"
                    // id="header_search_keywords"
                    style={{ borderRadius: "30px" }}
                    value={state.search_keywords}
                    placeholder={`${
                      isMobile
                        ? "Search doctor ..."
                        : "Search for your doctor, department or health screening package..."
                    }`}
                    onChange={handleChange}
                    onClick={showSearchResult}
                    onKeyUp={handleKeyUp}
                    autoComplete="off"
                  />
                  <div
                    className="d-flex justify-content-center align-items-center mx-auto flex-row"
                    style={{
                      position: "absolute",
                      right: 10,
                      bottom: isMobile ? 7 : 6,
                      backgroundColor: "#AF9763",
                      height: isMobile ? "18px" : "27px",
                      width: isMobile ? "18px" : "27px",
                      borderRadius: "50%",
                      padding: isMobile ? "3px" : "",
                    }}
                    onClick={showSearchResult}
                  >
                    <img src="/assets/images/search-header.png" alt="" />
                  </div>
                </div>

                <div className="">
                  <button
                    className="nav-link p-0 border-0 ms-2"
                    type="button"
                    data-bs-toggle="offcanvas"
                    data-bs-target="#cartOffcanvasRight"
                    aria-controls="cartOffcanvasRight"
                    to="/cart"
                  >
                    <div
                      style={{
                        position: "relative",
                      }}
                    >
                      {/* <MyContext.Consumer>
                          {(context) => {
                            const { totalQuantity } = context;
                            return (
                              <span
                                className="badge rounded-circle d-flex justify-content-center align-items-center"
                                style={{
                                  position: "absolute",
                                  top: -15,
                                  right: -10,
                                  height: "20px",
                                  width: "20px",
                                  border: "2px solid #292D32",
                                  textAlign: "center",
                                  padding: "5px",
                                  color: "black",
                                }}
                              >
                                {cart && totalQuantity}
                              </span>
                            );
                          }}
                        </MyContext.Consumer> */}

                      {/* if you want to show cart numbers dynamically then you can user the svg down bellow
                       */}
                      <svg
                        width={isMobile ? "25" : "30"}
                        height="30"
                        viewBox="0 0 30 30"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <g clip-path="url(#clip0_2516_10804)">
                          <path
                            d="M22.3769 0.0591259C21.5097 0.20561 20.5663 0.58647 19.7929 1.09038C19.1777 1.48881 11.9765 8.68999 11.578 9.30522C11.1972 9.8853 10.8691 10.6001 10.6874 11.2564C10.4999 11.9361 10.4296 13.3248 10.5468 14.0513C10.6347 14.6255 10.8984 15.4458 11.1503 15.938C11.83 17.2857 13.1015 18.4751 14.4374 19.0201C15.4277 19.4244 15.7265 19.4771 16.9921 19.4771C18.0468 19.4771 18.1816 19.4654 18.7089 19.3248C19.3534 19.149 20.1913 18.7623 20.7011 18.4107L21.0468 18.1763L21.4277 18.4693C22.0722 18.9556 22.8632 19.2955 23.7128 19.4595C24.1933 19.5474 25.5761 19.4947 26.0448 19.3658C26.6015 19.2134 27.5448 18.7271 28.0312 18.3404C28.2773 18.147 28.6347 17.7896 28.828 17.5435C29.2148 17.0572 29.7011 16.1138 29.8534 15.5572C30.0058 15.0123 30.0351 13.6705 29.9179 13.0611C29.7597 12.2935 29.3085 11.3267 28.8456 10.7876L28.6581 10.565L28.8984 10.2193C29.2441 9.71538 29.6191 8.89506 29.8007 8.26225C30.0058 7.51225 30.0644 6.09428 29.9179 5.30913C29.414 2.64311 27.3691 0.592329 24.7148 0.0884228C24.2167 -0.00532722 22.8632 -0.0229053 22.3769 0.0591259ZM23.9648 1.93413C25.0898 2.07475 25.9101 2.47319 26.7187 3.28178C27.1933 3.75639 27.3222 3.92045 27.5566 4.39506C27.9257 5.1392 28.0663 5.71342 28.0663 6.49858C28.0663 7.47124 27.8554 8.20366 27.3632 8.98881L27.1171 9.37553L26.9062 9.2642C26.3027 8.96538 25.4882 8.78959 24.6737 8.78959C23.6659 8.78959 22.8046 9.00639 22.0077 9.46342L21.5741 9.70952L19.623 7.75834L17.6659 5.80131L18.955 4.50639C20.3144 3.14116 20.748 2.76616 21.2694 2.47319C21.8261 2.16264 22.5937 1.94584 23.3788 1.88139C23.4316 1.88139 23.6952 1.90483 23.9648 1.93413ZM18.2577 9.14702L20.1972 11.0865L19.9511 11.5201C19.1659 12.8912 19.0546 14.6548 19.6523 16.1548L19.8456 16.6412L19.4706 16.8814C18.6913 17.3677 17.953 17.5787 16.9862 17.5787C14.4433 17.5787 12.4159 15.5572 12.4218 13.0142C12.4218 12.0005 12.6562 11.2154 13.1835 10.4302C13.3944 10.108 16.1894 7.20756 16.2831 7.20756C16.3007 7.20756 17.1913 8.08061 18.2577 9.14702ZM23.6718 14.1509V17.4615L23.3788 17.3501C22.4179 16.9869 21.5624 16.0083 21.2987 14.9712C21.1874 14.5259 21.1874 13.7701 21.2987 13.3306C21.5683 12.2994 22.3886 11.356 23.3554 10.9634C23.5136 10.899 23.6484 10.8462 23.6601 10.8462C23.6659 10.8404 23.6718 12.3287 23.6718 14.1509ZM26.4843 11.2505C27.1581 11.6783 27.7734 12.5279 27.9784 13.3013C28.0898 13.7056 28.0898 14.5845 27.9843 14.983C27.7089 16.0025 26.9999 16.8521 26.0331 17.2915C25.828 17.3853 25.6523 17.4615 25.6347 17.4615C25.6171 17.4615 25.6054 15.9732 25.6054 14.1509V10.8404L25.8984 10.9517C26.0624 11.0162 26.3261 11.1451 26.4843 11.2505Z"
                            fill="#292D32"
                          />
                          <path
                            d="M0.621064 8.14453C0.421846 8.20898 0.19333 8.4082 0.0820018 8.625C-0.0527638 8.88281 -0.023467 9.36914 0.140596 9.61523C0.415986 10.0195 0.404267 10.0195 3.15817 10.0195H5.61911L5.67185 10.207C6.20505 12.082 9.53317 22.8633 9.62106 22.9805C9.68552 23.0742 9.82028 23.1914 9.91989 23.25C10.0957 23.3437 10.705 23.3496 19.7168 23.3496C29.3027 23.3496 29.3261 23.3496 29.5312 23.2266C30.1347 22.875 30.1758 21.9551 29.6074 21.5801C29.455 21.4805 28.9922 21.4746 20.2793 21.4453L11.1093 21.416L9.15817 15.0059C7.35349 9.06445 7.20114 8.58398 7.02536 8.39648C6.91989 8.29101 6.73825 8.17383 6.62106 8.14453C6.36911 8.07422 0.861299 8.07422 0.621064 8.14453Z"
                            fill="#292D32"
                          />
                          <path
                            d="M24.8495 24.0587C23.7656 24.3517 22.8691 25.3536 22.6757 26.4845C22.4179 28.0079 23.3378 29.4669 24.8378 29.9064C25.2304 30.0236 26.0507 30.0294 26.455 29.9181C27.5449 29.631 28.4179 28.7111 28.6464 27.6095C28.9687 26.045 27.9902 24.4571 26.455 24.0529C26.0273 23.9415 25.2714 23.9474 24.8495 24.0587ZM26.0566 25.963C26.4316 26.1036 26.7714 26.6017 26.7773 27.006C26.7773 27.5685 26.2617 28.0665 25.6816 28.0665C25.33 28.0665 25.1249 27.9786 24.8906 27.7325C24.7206 27.5568 24.5507 27.1993 24.5507 27.0294C24.5507 26.6368 24.8495 26.1739 25.207 25.9982C25.4296 25.8868 25.8163 25.8693 26.0566 25.963Z"
                            fill="#292D32"
                          />
                          <path
                            d="M14.373 24.1056C13.6289 24.2873 12.8261 24.9084 12.4687 25.5822C12.0058 26.4435 12.0175 27.5392 12.4863 28.424C12.7089 28.84 13.2832 29.4025 13.6992 29.6134C14.8886 30.2169 16.3066 29.9884 17.2148 29.0392C17.7773 28.4533 18.0468 27.7853 18.0468 26.9826C18.0468 25.0724 16.2422 23.6544 14.373 24.1056ZM15.5273 26.0685C16.1367 26.3908 16.2949 27.1408 15.8613 27.6388C15.4277 28.1369 14.748 28.1369 14.3144 27.6388C13.6054 26.8302 14.5839 25.5587 15.5273 26.0685Z"
                            fill="#292D32"
                          />
                        </g>
                        <defs>
                          <clipPath id="clip0_2516_10804">
                            <rect width="30" height="30" fill="white" />
                          </clipPath>
                        </defs>
                      </svg>
                      {/* <img className="img-fluid" src="/assets/images/updated_cart.svg" alt="" srcset="" /> */}
                    </div>
                  </button>
                </div>
                <div className="nav-item">
                  {localStorage.getItem(USER_LOCAL_ID) ? (
                    <div className="dropdown navsdpdw">
                      <a
                        className="dropdown-toggle ms-2 d-flex justify-content-between align-items-center gap-2 text-decoration-none"
                        type="button"
                        id="dropdownMenuButton"
                        data-toggle="dropdown"
                        aria-haspopup="true"
                        aria-expanded="false"
                        style={{ color: "black" }}
                      >
                        <p className="userName">{UserName}</p>
                        <img
                          className="img-fluid"
                          style={{ maxWidth: isMobile ? "25px" : "30px" }}
                          src="/assets/images/User.png"
                          alt="logo2"
                        />
                      </a>
                      <div
                        className="dropdown-menu dropdown-menu-start"
                        aria-labelledby="dropdownMenuButton"
                      >
                        {patient_user_id ? (
                          <React.Fragment>
                            <a
                              className="dropdown-item btn disabled"
                              href="/patient-protal"
                            >
                              Patient ID: {patient_user_id}
                            </a>
                            <a className="dropdown-item" href="/patient-protal">
                              My Portal
                            </a>
                            <a
                              className="dropdown-item"
                              href="/pages/patientbillhistory"
                            >
                              Bill History
                            </a>
                          </React.Fragment>
                        ) : null}

                        <Link
                          className="dropdown-item"
                          to="/pages/packages"
                          // href={WEBSITEPAGE_URL + hmenu.slug}
                          // key={hmenu.title}
                        >
                          {/* {hmenu.title} */}
                          Packages
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="/pages/departments"
                          // href={WEBSITEPAGE_URL + hmenu.slug}
                          // key={hmenu.title}
                        >
                          {/* {hmenu.title} */}
                          Departments
                        </Link>
                        <Link
                          className="dropdown-item"
                          to="/pages/services"
                          // href={WEBSITEPAGE_URL + hmenu.slug}
                          // key={hmenu.title}
                        >
                          {/* {hmenu.title} */}
                          Services
                        </Link>
                        <a className="dropdown-item" href="/logout">
                          Logout
                        </a>
                      </div>
                    </div>
                  ) : (
                    <li className="d-flex align-items-center">
                      <div className="dropdown navsdpdw">
                        <a
                          className="btn btn-secondary dropdown-toggle dropdownMenu pe-0"
                          type="button"
                          id="dropdownMenuButton"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <img
                            style={{ maxWidth: isMobile ? "25px" : "30px" }}
                            src="/assets/images/User.png"
                            alt="logo2"
                          />
                        </a>
                        <div
                          className="dropdown-menu"
                          aria-labelledby="dropdownMenuButton"
                        >
                          <a
                            className="dropdown-item"
                            href="#offcanvasExample"
                            data-bs-toggle="offcanvas"
                            role="button"
                            aria-controls="offcanvasExample"
                          >
                            Login/Sign up
                          </a>
                          <Link
                            className="dropdown-item"
                            to="/pages/packages"
                            // href={WEBSITEPAGE_URL + hmenu.slug}
                            // key={hmenu.title}
                          >
                            {/* {hmenu.title} */}
                            Packages
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="/pages/departments"
                            // href={WEBSITEPAGE_URL + hmenu.slug}
                            // key={hmenu.title}
                          >
                            {/* {hmenu.title} */}
                            Departments
                          </Link>
                          <Link
                            className="dropdown-item"
                            to="/pages/services"
                            // href={WEBSITEPAGE_URL + hmenu.slug}
                            // key={hmenu.title}
                          >
                            {/* {hmenu.title} */}
                            Services
                          </Link>
                        </div>
                      </div>
                    </li>
                  )}
                </div>
                <div className="d-block d-md-none">
                  <HiMenuAlt3
                    data-bs-toggle="offcanvas"
                    data-bs-target="#sideBarMenus"
                    aria-controls="sideBarMenus"
                    style={{ fontSize: "25px", color: "#F58220" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </nav>

        <div className="row container-fluid">
          <div className="col-sm-1"></div>
          <div className="col-12 col-md-8">
            <div className="search-popup-main ">
              <div
                className="search-popup rounded-bottom"
                style={{
                  display: state.showSearchPopup ? "block" : "none",
                  overflowY: "scroll",
                  height: "424px",
                  zIndex: "99999",
                }}
                onMouseLeave={closeSearchPopUp}
              >
                <h4>Specialists</h4>
                <hr className="lists-line" />
                <div className="row mt-4">
                  {state.default_doctors && state.default_doctors.length > 0 ? (
                    state.default_doctors.map((default_search_doctor) => {
                      let doctor_name = default_search_doctor.doctor_name;
                      let new_doctor_name = doctor_name.replaceAll(" ", "-");
                      return (
                        <div className="col-lg-4 col-md-6 col-sm-12 mt-4 d-flex justify-content-center">
                          <div className="doctor-list w-100">
                            <a
                              href={
                                SITE_URL +
                                "/consultant/" +
                                default_search_doctor.slug
                              }
                              style={{
                                textDecoration: "none",
                                color: "#212529",
                              }}
                            >
                              <div className="row">
                                <div className="col-5">
                                  {default_search_doctor.doctor_profile ? (
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "/DoctorProfileImg/" +
                                        default_search_doctor.doctor_profile
                                      }
                                      alt="Bitmap-3"
                                      style={{
                                        objectFit: "cover",
                                        height: "120px",
                                        width: "100%",
                                        objectPosition: "top",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                      alt="Bitmap-3"
                                      style={{
                                        objectFit: "cover",
                                        height: "120px",
                                        width: "100%",
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="col-7">
                                  <h6 style={{ fontSize: "14px" }}>
                                    {default_search_doctor.doctor_name}
                                  </h6>
                                  <p style={{ fontSize: "12px" }}>
                                    {default_search_doctor.degree}
                                  </p>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-lg-12 col-md-12">
                      <div className="doctor-list">
                        <div className="row">
                          <p style={{ fontSize: "12px" }}>no result found</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <br />
                <br />
                <h4>Departments</h4>
                <hr className="lists-line" />
                <div className="row mt-4">
                  {state.default_departments ? (
                    state.default_departments.map((department) => {
                      let department_name = department.department_name;
                      // let new_doctor_name = doctor_name.replaceAll(' ', '-');
                      return (
                        <div className="col-lg-4 col-md-12 mt-4">
                          <div className="doctor-list">
                            <a
                              href={
                                SITE_URL + "/departments/" + department.slug
                              }
                              style={{
                                textDecoration: "none",
                                color: "#212529",
                              }}
                            >
                              <div className="row align-items-center">
                                <div className="col-5">
                                  {department.image ? (
                                    <img
                                      src={
                                        IMAGE_URL +
                                        "/DepartmentImage/" +
                                        department.image
                                      }
                                      alt="Bitmap-3"
                                      style={{
                                        objectFit: "contain",
                                        height: "120px",
                                        width: "100%",
                                        padding: "5px",
                                      }}
                                    />
                                  ) : (
                                    <img
                                      src="https://static.vecteezy.com/system/resources/thumbnails/003/337/584/small/default-avatar-photo-placeholder-profile-icon-vector.jpg"
                                      alt="Bitmap-3"
                                      style={{
                                        objectFit: "contain",
                                        height: "120px",
                                        width: "100%",
                                        padding: "5px",
                                      }}
                                    />
                                  )}
                                </div>
                                <div className="col-7">
                                  <h6
                                    className="m-0 p-0"
                                    style={{ fontSize: "14px" }}
                                  >
                                    {department_name}
                                  </h6>
                                  {/* <p style={{ "fontSize": "12px" }}>{default_search_doctor.degree}</p> */}
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-lg-12 col-md-12">
                      <div className="doctor-list">
                        <div className="row">
                          <p style={{ fontSize: "12px" }}>no result found</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <br />
                <br />
                <h5>Packages</h5>
                <hr className="lists-line" />
                <div className="row mt-4">
                  {state.default_packages &&
                  state.default_packages.length > 0 ? (
                    state.default_packages.map((default_search_packages) => {
                      let package_name = default_search_packages.name;
                      let new_package_name = package_name.replaceAll(" ", "-");
                      return (
                        <div className="col-lg-4 col-sm-12">
                          <div className="Package-part">
                            <a
                              href={SITE_URL + "/packages/" + new_package_name}
                              style={{
                                textDecoration: "none",
                                color: "#212529",
                              }}
                            >
                              <div className="row">
                                <div className="col-4 sp-0-search">
                                  <img
                                    src={
                                      IMAGE_URL +
                                      "Packagesimg/202303221003packages%20Profile.png"
                                    }
                                    style={{
                                      objectFit: "cover",
                                      height: "120px",
                                      width: "100%",
                                    }}
                                    alt="icons-rotate"
                                  />
                                </div>
                                <div className="col-8 sp-0-search bg-color-gry">
                                  <h6 style={{ fontSize: "16px" }}>
                                    {default_search_packages.name}
                                  </h6>
                                </div>
                              </div>
                            </a>
                          </div>
                        </div>
                      );
                    })
                  ) : (
                    <div className="col-lg-12 col-sm-12">
                      <div className="Package-part">
                        <div className="row">
                          <p>No packages found</p>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
                <br />
                <br />
              </div>
            </div>
          </div>
        </div>

        {/*</div>*/}
      </header>
      {state.patientRegPopup ? (
        <PatientRegisterPopup showpopup={state.showPatientRegPopup} />
      ) : null}
      <CartPopUp></CartPopUp>
      <BookTestPopUp></BookTestPopUp>
      <CorporateRequestPopUp></CorporateRequestPopUp>
    </div>
  );
};

export default Header;



// WEBPACK FOOTER //
// ./src/component/frontend/Header.js